<template>
  <v-snackbar :value="visible" :timeout="-1" bottom color="warning" class="restoration-maintenance-notice">
    {{ ended ? 'Le traitement de restauration est terminé. Actualisez pour recharger les données et vos droits.' : 'Une restauration est en cours. Merci de patienter ; les accès métier concernés sont suspendus.' }}
    <template v-slot:action><v-btn text @click="reload">Actualiser</v-btn></template>
  </v-snackbar>
</template>
<script>
import api from '@/services/api'
export default {
  name: 'RestorationMaintenanceNotice',
  data: () => ({ signalled: false, ended: false }),
  computed: {
    identity() { const user = this.$store.getters.currentUser || {}; return [user.uuid || '', user.profil_id || ''].join(':') },
    fromSession() { return !!(this.$store.getters.currentUser || {}).maintenance },
    visible() { return this.fromSession || this.signalled || this.ended },
  },
  watch: {
    identity() { this._generation++; this.signalled = false; this.ended = false; clearTimeout(this._timer); if (this.fromSession) this.check() },
    fromSession(value) { if (value) this.check() },
  },
  created() { this._generation = 0; this._timer = null; this._checking = false },
  mounted() { window.addEventListener('restoration-maintenance', this.signal); document.addEventListener('visibilitychange', this.visibility); if (this.fromSession) this.check() },
  beforeDestroy() { this._generation++; clearTimeout(this._timer); window.removeEventListener('restoration-maintenance', this.signal); document.removeEventListener('visibilitychange', this.visibility) },
  methods: {
    reload() { window.location.reload() },
    signal() { this.signalled = true; this.ended = false; this.check() },
    visibility() { clearTimeout(this._timer); if (!document.hidden && this.visible && !this.ended) this.check() },
    async check() {
      if (this._checking || document.hidden || !(this.$store.getters.currentUser || {}).uuid) return
      this._checking = true; const generation = this._generation
      try {
        const response = await api.get('/engine/backup-maintenance')
        if (generation !== this._generation || this._isBeingDestroyed) return
        if (response.data && response.data.success && !response.data.maintenance) this.ended = true
      } catch (error) { /* Conserver le message tant que la disponibilité n'est pas confirmée. */ }
      finally {
        this._checking = false
        if (generation === this._generation && !this._isBeingDestroyed && !document.hidden && !this.ended) { clearTimeout(this._timer); this._timer = setTimeout(() => this.check(), 15000) }
      }
    },
  },
}
</script>
<style>.restoration-maintenance-notice { z-index: 3000 !important; }</style>
